module.exports = __webpack_public_path__ + "gm.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/gm.svg
// module id = 572
// module chunks = 0